import { maxWidth } from '@/assets/styles/mixins.css.js'
import styled from 'styled-components'
import vars from '@/assets/styles/vars'

const GridArticle = styled.article`
  &::after {
    content: '';
    display: block;
    width: 100%;
    padding-top: 80%;
    background: rgb(14, 13, 27);
    background: linear-gradient(
      0deg,
      rgba(14, 13, 27, 0.8) 0%,
      rgba(14, 13, 27, 0) 50%,
      rgba(14, 13, 27, 0) 66%,
      rgba(14, 13, 27, 0.34) 100%
    );
  }

  ${maxWidth(vars.breakpoints.tablet)`
    min-height: 100%;

    &::after {
      content: none;
    }
  `}
`

GridArticle.Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: #fff;
`

GridArticle.Img = styled.div`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;

  &::after {
    content: none;
    display: block;
    width: 100%;
    padding-top: 50%;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    position: relative;
    height: auto;
    margin-bottom: 24px;

    &::after {
      content: '';
    }
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    margin-bottom: 16px;
  `}
`

GridArticle.Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  padding: 64px 32px 32px;

  ${maxWidth(vars.breakpoints.tablet)`
    position: static;
    height: auto;
    padding: 0 20px 0 0;
  `}
`

GridArticle.Title = styled.h3`
  --article-title-font-size: 24px;
  --article-title-line-height: 1.2;
  --article-title-max-lines: 3;

  order: 2;
  display: block;
  display: -webkit-box;
  max-height: calc(
    var(--article-title-font-size) * var(--article-title-line-height) *
      var(--article-title-max-lines)
  );
  -webkit-line-clamp: var(--article-title-max-lines);
  -moz-line-clamp: var(--article-title-max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 24px;
  font-weight: normal;
  font-size: var(--article-title-font-size);
  line-height: var(--article-title-line-height);
  color: var(--article-title-color, #fff);

  ${maxWidth(vars.breakpoints.tablet)`
    --article-title-color: var(--color-main);
    --article-title-font-size: 18px;
  `}
`

GridArticle.Date = styled.div`
  --article-date-color: #fff;

  order: 1;
  margin: 0 0 16px;
  font-weight: bold;
  font-size: 12px;
  line-height: 1.2;
  letter-spacing: 0.04em;
  color: #fff;

  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 11px;
    color: var(--color-extra);
  `}

  ${maxWidth(vars.breakpoints.lMobile)`
    margin-bottom: 12px;
  `}
`

GridArticle.Arrow = styled.div`
  order: 3;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.2;
  color: #fff;

  svg {
    vertical-align: middle;
    width: 20px;
    height: auto;
    margin-left: 8px;
    transform: rotate(180deg);
  }

  ${maxWidth(vars.breakpoints.tablet)`
    color: var(--color-decor);
    font-size: 14px;
  `}
`

GridArticle.Link = styled.a`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

export default GridArticle
